import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const mediaUrl = (src) => (src && src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src || "");

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d?.msg || d);
}
